<template>
  <div class="head">
    <div class="box">
      <div class="logo"></div>
      <div class="r">
        <div class="box1">
          <el-menu
            :default-active="activeIndex"
            @select="handleSelect($event)"
            class="el-menu-demo"
            mode="horizontal"
          >
            <el-menu-item index="1">首页</el-menu-item>
            <el-menu-item index="2" class="pos">融创产品
            <div class="boxs">
              <div class="hovers">
                <div class="left">
                  <h2>软件平台系统</h2>
                  <ul>
                    <li @click="got(1)">
                      <a >智慧微格教学平台</a>
                    </li>
                    <li @click="got(2)">
                      <a >融创教学平台</a>
                    </li>
                    <li @click="got(3)">
                      <a >融创教学可视化大数据系统</a>
                    </li>
                    <li @click="got(4)">
                      <a >融创教学形成性评价系统</a>
                    </li>
                    <li @click="got(5)">
                      <a >督导巡课系统</a>
                    </li>
                  </ul>
                </div>
                <div class="right">
                  <h2>硬件产品</h2>
                  <ul>
                    <li @click="got(6)">
                      <a>智慧黑板</a>
                    </li> 
                    <li @click="got(7)">
                      <a >电子班牌</a>
                    </li>
                    <li @click="got(6)">
                      <a >微格教学工作台</a>
                    </li>
                    <li @click="got(6)">
                      <a >教学行为训练系统（魔镜）</a>
                    </li>
                    <li @click="got(7)">
                      <a >数智化实训示教系统</a>
                    </li>
                    <li @click="got(10)">
                      <a >融创常态化录播主机</a>
                    </li>
                  </ul>
                </div>
                <div class="left">
                  <h2></h2>
                  <ul>
                    <li @click="got(8)">
                      <a>智能电控锁</a>
                    </li>
                    <li @click="got(8)">
                      <a >智慧实训联动倒计时提示终端</a>
                    </li>
                    <li @click="got(9)">
                      <a >智慧实验室环境监测感知终端</a>
                    </li>
                    <li @click="got(8)">
                      <a >智慧实验室电能管理终端</a>
                    </li>
                    <li @click="got(9)">
                      <a >4K双目智能教学跟踪摄像机</a>
                    </li>
                    <li @click="got(10)">
                      <a >融创4K研讨型录播主机</a>
                    </li>
                    
                  </ul>
                </div>
              </div>
            </div>
            </el-menu-item>
            <el-menu-item index="3">系统方案</el-menu-item>
            <el-menu-item index="4">关于我们</el-menu-item>
            <el-menu-item index="5">联系我们</el-menu-item>
          </el-menu>
        </div>
        <div class="box2">
          <div class="posd">
            <!-- <div class="phoneImg"></div> -->
            <div>
              <!-- <span style="display: inline-block;">400-855-7908</span><br> -->
              <!-- <span>15210807987 彭先生</span>
              <span class="xx">（微信同号）</span> -->
            </div>
           
          </div>
          <!-- <i class="el-icon-phone-outline"></i> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from '../utils/event-bus';
export default {
  data() {
    return {
      activeIndex: sessionStorage.getItem('router') || "1",
    };
  },
  watch: {
    '$route': {
      handler(to, from) {
      // console.log('当前页面路由：' + to.path);
      // console.log('上一个路由：' + from.path);
      if(to.path == '/'){ 
        this.activeIndex= '1'
      }
      if(to.path == '/product'){
        this.activeIndex= '2'
      }
      if(to.path == '/system'){
        this.activeIndex= '3'
      }
      if(to.path == '/about'){
        this.activeIndex= '4'
      }
      if(to.path == '/connection'){
        this.activeIndex= '5'
      }
    },
    // deep: true,
    // immediate: true
    },
    activeIndex:{
      handler(to, from){
        console.log(to,from);
        sessionStorage.setItem('router',to+'')
      },
      deep: true,
      immediate: true
    }
    },
  methods:{
    handleSelect(e){
      console.log(e);
      if(sessionStorage.getItem('router') == e) return
      if(e==1){
        this.$router.push('/')
      }
      if(e==2){
        this.$router.push('/product')
      }
      if(e==3){
        this.$router.push('/system')
      }
      if(e==4){
        this.$router.push('/about')
      }
      if(e==5){
        this.$router.push('/connection')
      }
      sessionStorage.setItem('router',e)
      this.activeIndex = e+''
    },
    got(e){
      if(!sessionStorage.getItem('scrollNum')){
        sessionStorage.setItem('scrollNum',e)
        // this.$router.push('/product')
      }else{
        sessionStorage.setItem('scrollNum',e)
      }
      EventBus.$emit('custom-event', { data: e });
      // this.$router.push('/product')
      // this.$router.push({ path: '/product#product'+ e });
      
    }
  }
};
</script>

<style scoped lang="scss">
*{
  padding: 0;
  margin: 0;
}
a{
  text-decoration:none;
}
ul,li{
  list-style: none;
  padding: 0;
}
.head {
  .box {
    display: flex;
    margin: 0 auto;
    width: 1200px;
    min-width: 1200px;
    justify-content: space-between;
  }

  .r {
    display: flex;
  }

  .logo {
    margin-right: 116px;
    margin: auto 116px auto 0;
    width: 196px;
    height: 46px;
    min-width: 196px;
    background: url("~@/assets/imgs/logo.png");
    background-size: 100% 100%;
  }

  .box1 {
    ::v-deep .el-menu.el-menu--horizontal {
      border-bottom: none;
    }

    ::v-deep .el-menu-item {
      height: 70px;
      line-height: 70px;
      padding: 0;
      margin: 10px 30px;
      font-size: 20px;
      font-family: Microsoft YaHei, Microsoft YaHei-Bold;
      font-weight: 500;
      color: #000;
    }

    ::v-deep .el-menu--horizontal > .el-menu-item.is-active {
      border-bottom: 3px solid #004ea1;
      color: #004ea1;
      font-weight: 700;
    }
  }

  .box2 {
    margin: auto 0 auto 30px;
    font-size: 20px;
    font-family: Microsoft YaHei, Microsoft YaHei-Bold;
    font-weight: 700;
    color: #000000;
    display:flex;
    align-items: center;
    width: 198px;
    position: relative;
    .posd{
      display: flex;
      align-items: center;
      position: absolute;
      width: 290px;
    }
    .phoneImg{
      background: url('@/assets/imgs/iocn电话@2x.png');
      width: 16px;
      height: 18px;
      background-size: 100% 100%;
      margin-right: 10px;
    }
  }
}
.pos{
  position: relative;
  .boxs{
    position: absolute;
    top: 70px;
    // margin-top: 20px;
    left: -20px;
    padding-top: 20px;
    display: none;
    z-index: 10;
  }
  .hovers{
    padding: 16px 0 16px 20px;
    // width: 336px;
    height: 212px;
    background: #ffffff;
    border-radius: 11px;
    display: flex;
    position: relative;
    &::before{
        content: "";
        height: 1px;
        width: 100%;
        background-color: #c2c2c2;
        position: absolute;
        left: 0px;
        top: 35px;
        // box-shadow: 0 0 10px #eeeeee;
    }
    // display: none;
    h2{
      // width: 72px;
      height: 16px;
      font-size: 12px;
      line-height: 16px;
      font-family: Source Han Sans CN, Source Han Sans CN-Medium;
      font-weight: 500;
      text-align: left;
      color: #004ea1;
      // border-bottom:1px solid #2b2b2b ;
    }
    .left,.right{
      ul{
        li{
          // width: 96px;
          height: 16px;
          line-height: 16px;
          font-size: 12px;
          font-family: Source Han Sans CN, Source Han Sans CN-Medium;
          font-weight: 500;
          text-align: left;
          color: #0a0a0a;
         padding-top: 16px;
         &:hover{
          color: #004ea1;
         }
        }
      }
    }
    .left,.right{
      margin-right: 20px;
    }
  }
  &:hover{
    .boxs{
      display: flex;
    }
  }
}
.xx{
  font-size: 14px;
  // color: rgba(#010101, 0.5);
}
</style>